var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMatrixCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M20.938 2.5C22.075 2.5 23 3.412 23 4.536v14.928c0 1.124-.924 2.036-2.063 2.036H3.063C1.925 21.5 1 20.588 1 19.464V4.536C1 3.412 1.924 2.5 3.063 2.5zM6 15.732H2.719v3.563c0 .28.232.509.515.509H7.76L7.758 18h-.472C6.576 18 6 17.424 6 16.714v-.982zM14.517 18h-5.04v1.804h5.041L14.517 18zm6.764-2.268H18v.982c0 .71-.576 1.286-1.286 1.286h-.473v1.804h5.04v-4.072zm-6.333-6.5l-4.02 4.02-1.876-1.876a.427.427 0 00-.606 0l-.606.606a.427.427 0 000 .606l2.786 2.785a.427.427 0 00.606 0l4.928-4.928a.427.427 0 000-.606l-.606-.606a.427.427 0 00-.606 0zM6 9.965H2.719v4.072L6 14.035V9.964zm15.281 0H18v4.071h3.281v-4.07zM7.76 4.196H3.234a.515.515 0 00-.515.51v3.562L6 8.267v-.981C6 6.576 6.576 6 7.286 6h.472l.001-1.804zm13.522 0h-5.04V6h.473C17.424 6 18 6.576 18 7.286v.981h3.281v-4.07zm-6.763 0h-5.04L9.477 6h5.04l.001-1.804z"
  }))));
}

export default SvgMatrixCheckbox;